import { render } from "./ProspectVacancies.vue?vue&type=template&id=7a84fdd4"
import script from "./ProspectVacancies.vue?vue&type=script&lang=js"
export * from "./ProspectVacancies.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__